import { Link } from "@tanstack/react-router";
import logoSrc from "../assets/logolibertad-transparent.png";

interface LogoProps {
  variant?: "light" | "dark";
  className?: string;
}

export function Logo({ variant = "dark", className = "" }: LogoProps) {
  const isOnDark = variant === "light";
  const imageSize = isOnDark ? "h-14 md:h-16" : "h-16 md:h-20";

  return (
    <Link
      to="/"
      aria-label="Estudio Libertad — Consultores y Abogados"
      className={`inline-flex shrink-0 items-center ${className}`}
    >
      <span
        className={
          isOnDark
            ? "inline-flex items-center justify-center bg-stone-100 px-4 py-2"
            : "inline-flex items-center"
        }
      >
        <img
          src={logoSrc}
          alt="Estudio Libertad — Consultores y Abogados"
          className={`block w-auto ${imageSize}`}
        />
      </span>
    </Link>
  );
}
